import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
import gameMg from "./groMore/groMoregameMg";
import appMg from "./groMore/groMoreappMg";
import { tabulation } from "@/mixins/index";
export default {
  name: "groMore",
  mixins: [tabulation],
  components: {
    gameMg: gameMg,
    appMg: appMg
  },
  data: function data() {
    return {
      activeIndex: 'appMg'
    };
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    modelChange: function modelChange(e) {
      this.activeIndex = e;
    }
  }
};